/* Shared config for the Guardian à la carte pricing calculator. */

export const SUN_DEEP = "#C98F00";
export const SUN = "#F5B400";
export const INK = "#0F1E2E";
export const EMBER = "#FF7B1F";
export const CREAM = "#FDFBF5";

export const CORE_MONTHLY = 1000; // per company / mo, always included

export const CORE_INCLUSIONS = [
  "Portfolio dashboard + rules-based scoring",
  "CompliMind AI assistant (closed system)",
  "Quarterly Report Cards on every company",
  "Attorney-led escalation path",
  "Regulatory horizon alerts",
  "Policies & procedures library (single source of truth)",
  "Agreements / consents / disclosures library",
  "Issue management",
];

/* Per-company modules (discountable). */
export const MODULES = [
  {
    key: "aml",
    label: "AML screening & watchlist monitoring",
    price: 450,
    footnote:
      "Includes up to 100 individual screenings + continuous monitoring per company / month. Additional screenings $3 each.",
  },
  {
    key: "vendor",
    label: "Vendor oversight (TPRM)",
    price: 500,
    footnote:
      "Includes up to 40 business screenings per company / month. Additional business screenings $8 each.",
  },
  {
    key: "complaints",
    label: "Complaint management (UDAAP)",
    price: 350,
    footnote: null,
  },
  {
    key: "marketing",
    label: "Marketing review",
    price: 350,
    footnote: null,
  },
];

export const SCREENING_LIMITS = {
  aml: { included: 100, overage: 3, unit: "screening" },
  vendor: { included: 40, overage: 8, unit: "business screening" },
};

/* High-volume onboarding — attaches to AML for end-user KYC pipelines. */
export const HV = {
  base: 750,
  perCompanyOver: 12,
  baseCompanies: 5,
};

/* Company-count → volume discount (per-co stack only; 51+ = contact us). */
export const COMPANY_TIERS = [
  { min: 1,  max: 4,   discount: 0.00, label: "1–4"   },
  { min: 5,  max: 10,  discount: 0.10, label: "5–10"  },
  { min: 11, max: 25,  discount: 0.15, label: "11–25" },
  { min: 26, max: 50,  discount: 0.20, label: "26–50" },
  { min: 51, max: 9999, discount: null, label: "51+", custom: true },
];

export function findCompanyTier(n) {
  return COMPANY_TIERS.find((t) => n >= t.min && n <= t.max) || COMPANY_TIERS[0];
}

/* Fractional team — portfolio-level, NOT × companies, NOT discounted. */
export const ROLES = [
  { key: "cco",       label: "Fractional CCO",              committed: 150, adhoc: 250, min: 5, max: 20, default: 10 },
  { key: "bsa",       label: "BSA/AML Officer",             committed: 150, adhoc: 250, min: 5, max: 15, default: 10 },
  { key: "principal", label: "Principal Compliance Lead",   committed: 150, adhoc: 250, min: 5, max: 15, default: 10 },
  { key: "analyst",   label: "Compliance Analyst / Ops",    committed: 75,  adhoc: 125, min: 5, max: 15, default: 10 },
];

/* Training — per-seat, per-year, flat volume tier. */
export const TRAINING_TIERS = [
  { upTo: 25,   perSeat: 60 },
  { upTo: 50,   perSeat: 45 },
  { upTo: 100,  perSeat: 35 },
  { upTo: 9999, perSeat: 25 },
];

export function trainingRate(seats) {
  for (const t of TRAINING_TIERS) if (seats <= t.upTo) return t.perSeat;
  return TRAINING_TIERS[TRAINING_TIERS.length - 1].perSeat;
}

/* Internal ComplyCube unit costs — ADMIN ONLY, never surfaced to client. */
export const CC_COSTS = {
  onboarding_passive: 1.70,
  onboarding_active:  2.45,
  vendor_screen:      4.85,
  monitoring_profile: 0.03,
  shared_balance:     500,
};

export const fmt = (n) => `$${Math.round(n).toLocaleString()}`;
export const fmt0 = (n) => `$${n.toLocaleString()}`;
export const fmt2 = (n) => `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
